module.exports = __webpack_public_path__ + "media/role_selection/walker-0f04d3ee.png";